module.exports = __webpack_public_path__ + "static/media/airbnb2.5e92f252.png";